import cx from 'classnames';
import { FunctionComponent } from 'react';

import IconNoImage from '../icons/no-image';

export type TNoImage = {
  variant?: 'gray' | 'white' | 'transparent';
  color?: string;
  label?: string;
};

const getVariant = (variant: TNoImage['variant']) => {
  switch (variant) {
    case 'transparent':
      return '';
    case 'white':
      return 'bg-white';
    case 'gray':
    default:
      return 'bg-neutral-10';
  }
};

const NoImage: FunctionComponent<TNoImage> = ({
  variant = 'gray',
  color = 'text-white',
  label /* ONLY for product detail && vehicle detail */,
}) => (
  <div
    className={cx(
      getVariant(variant),
      'grid',
      'w-full',
      'h-full',
      'justify-center',
      'items-center'
    )}
  >
    <div className={cx('text-center', color)}>
      <IconNoImage className={cx('inline-block', 'h-9')} />
      {label && <div className={cx('text-xs', 'mt-3', 'px-4')}>{label}</div>}
    </div>
  </div>
);

export default NoImage;
